<template>
  <div class="h6 mb-0">
    <!-- <div :content="errorLampDesc(lamp)"> -->
    <div>
        <!---- gestione tipo di errore -->
        <i class="fa fa-2x" :class="[dotClass]" :content="errorDesc" v-tippy="{ placement: 'top', arrow: true }"/>

    </div>
  </div>
</template>

<script>

export default {
    name: "IconErrorCentral",
    props: {
        dev: {
            default: null
        },
        errorComEnabled: false,
        errorHardwareEnabled: false,
        errorLedEnabled: false,
        errorBatteryEnabled: false,
        errorOtherEnabled: false
    },
    data() {
        return {
        };
    },

    computed: {
        dotClass()
        {
            var stato = null;
            if (this.dev.cu_error)
            {
                if ((this.dev.cu_type == 'sicuro') && ((this.dev.cu_error.error_general == 'ON') || (this.dev.num_lamp_error > 0)))
                {
                    return "fa-exclamation-circle check-err";
                }
                if (this.dev.num_lamp_error > 0 || this.dev.cu_error.error_overload == 'ON' || this.dev.cu_error.errorwiring == 'ON' || this.dev.num_nodi_orfani > 0)
                {
                    stato = "fa-exclamation-circle check-err";
                    if (this.dev.num_lamp_error > 0 && (this.errorComEnabled == true && this.errorHardwareEnabled==false && this.errorBatteryEnabled==false && this.errorLedEnabled==false && this.errorOtherEnabled==false))
                        stato = "fa-exclamation-circle check-com-err";
                }
                else if (this.dev.num_lamp_found == 0 || this.dev.cu_error.error_missing_lamp_in_config == 'ON' || this.dev.cu_error.error_too_much_lamp_in_config == 'ON')
                {
                    stato = "fa-check check-not-config";
                }
                else
                {
                    if (this.dev.cu_type != 'sicuro') {
                        if (this.dev.cu_status.emergency_running == 'ON')
                            stato = "fa-exclamation-circle emergency-on"
                        else
                            stato = "fa-check check-ok";
                    } else {
                        stato = "fa-check check-ok";
                    }
                }
                return stato
            }

            if (this.dev.cu_type == "blegateway")
            {
                if (this.dev.num_lamp_error > 0) 
                {
                    stato = "fa-exclamation-circle check-err";
                }
                else if (this.dev.num_lamp_found == 0) 
                {
                    stato = "fa-check check-not-config";
                }
                else
                {
                    stato = "fa-check check-ok";
                }

                return stato
            }
        },


        errorDesc()
        {

            var stato_desc = [];
            var errori = this.dev.cu_error;

            if (errori.error_batt_low_voltage === "ON" && errori.error_batt_not_connected === "OFF") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_batt_low_voltage"));
            }
            if (errori.error_batt_not_connected=="ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_batt_not_connected"));
            }
            if (errori.error_duplicated_id_lamp=="ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_duplicated_id_lamp"));
            }
            
            if (errori.error_lg === "ON" || this.dev.num_lamp_error > 0 || this.dev.num_nodi_orfani > 0) {
                if (this.dev.cu_type !== "sicuro") {
                    stato_desc.push(this.$t("details_cu_modal.cu_error_lg"));
                }
            }
            if (errori.error_wiring === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_wiring"));
            }
            if (errori.error_too_much_lamp_in_config === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_too_much_lamp_in_config"));
            }
            if (errori.error_overload === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_overload"));
            }
            if (errori.error_missing_lamp_in_config === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_missing_lamp_in_config"));
            }
            if (errori.error_more_32_lamp_in_config === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_more_32_lamp_in_config"));
            }
            if (errori.error_more_128_lamp_in_config === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_more_128_lamp_in_config"));
            }
            if (errori.err_data_invalid === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_date_time_invalid"));
            }
            if (errori.err_UART1 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART1"));
            }
            if (errori.err_UART2 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART2"));
            }
            if (errori.err_UART3 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART3"));
            }
            if (errori.err_UART3_modem_powerON === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_modem_off"));
            }
            if (errori.err_UART4 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART4"));
            }
            if (errori.err_UART5 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART5"));
            }
            if (errori.err_UART6 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART6"));
            }
            if (errori.err_UART7 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_UART7"));
            }
            if (errori.error_ak_o_luci === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_subdisp"));
            }
            if (errori.error_battery_fuse === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_batt_fuse"));
            }
            if (errori.error_battery_low === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_batt_low_voltage"));
            }
            if (errori.error_battery_symmetry === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_batt_simm"));
            }
            if (errori.error_battery_temperature === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_batt_temp"));
            }
            if (errori.error_io_measures === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_io_measures"));
            }
            if (errori.error_com_cpu_io === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_IO"));
            }
            if (errori.error_com_cpu_ak === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_cpu_AK"));
            }
            if (errori.error_com_cpu_akext === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_cpu_AKext"));
            }
            if (errori.error_com_cpu_switch11kw === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_switch11kw"));
            }
            if (errori.error_com_cpu_charger === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_charger"));
            }
            if (errori.error_com_cpu_lssa === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_lssa"));
            }
            if (errori.error_com_cpu_substation === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_com_sub"));
            }
            if (errori.error_all_chargers_or_fuse === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_all_chargers"));
            }
            if (errori.error_chargers === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_caricatori"));
            }
            if (errori.error_cabinet_isominus === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_isominus"));
            }
            if (errori.error_cabinet_isoplus === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_isoplus"));
            }
            if (errori.error_line_isolation === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_line_isol"));
            }
            if (errori.error_lamp_programming === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_prog_lamp"));
            }
            if (errori.error_autonomy_test === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_last_duration_test"));
            }
            if (errori.error_functional_test === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_last_funz_test"));
            }
            if (errori.error_power_supply_broken === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_power_supply_broken"));
            }
            if (errori.error_power_supply_out_of_range === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_error_power_supply_out_of_range"));
            }
            if (errori.warning_charger_off_by_temperature === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_charger_off_by_temp"));
            }
            if (errori.warning_maintenance === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_maintenance"));
            }
            if (errori.no_mains === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_no_main"));
            }
            if (errori.no_phase1 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_no_phase1"));
            }
            if (errori.no_phase2 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_no_phase2"));
            }
            if (errori.no_phase3 === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_no_phase3"));
            }
            if (errori.system_inhibited === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_system_inhibited"));
            }
            if (errori.no_subdistribution === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_sub_dis"));
            }
            if (errori.no_critical_circuit === "ON") {
                stato_desc.push(this.$t("details_cu_modal.cu_warning_critical"));
            }

            if (stato_desc.length === 0) {
                stato_desc.push(this.$t("details_lamp.lamp_no_error"));
            }
            return stato_desc.join("<br>"); // trasformo l'array in stringa separata da ritorno a capo
        },
    },

    methods: {

    }
   
  }
  
</script>
